export default {
  message: {
    "error": "เกิดข้อผิดพลาด!",
    "Sorrysomeerrorsoccurred": "ขอโทษค่ะ เกิดข้อผิดพลาดบางประการ",
    "quit": "ออก",
    "language": "ภาษา",
    "Youcanchangethelanguagehere": "คุณสามารถเปลี่ยนภาษาได้ที่นี่!",
    "current": "ปัจจุบัน",
    "home": "หน้าแรก",
    "friends": "เพื่อน",
    "wallet": "กระเป๋าเงิน",
    "aboutus": "เกี่ยวกับเรา",
    "Sharewithfriends": "แชร์กับเพื่อน",
    "copyFailure": "คัดลอกล้มเหลว",
    "copySuccess": "คัดลอกสำเร็จ",
    "Claimreward": "รับรางวัล",
    "DailyLogin": "เข้าสู่ระบบประจำวัน",
    "noInvitationsYet": "ยังไม่มีคำเชิญ",
    "LoadMore": "โหลดเพิ่มเติม",
    "WatchAD": "ชมโฆษณา",
    "continue": "ดำเนินการต่อ",
    "Congratulations": "ขอแสดงความยินดี",
    "MyFriends": "เพื่อนของฉัน",
    "Invitefriends": "เชิญเพื่อน",
    "Invitepremiumfriends": "เชิญเพื่อนระดับพรีเมียม",
    "DailyTasks": "งานประจำวัน",
    "inviteDesc": "+{num} ${name} ต่อเพื่อนแต่ละคนที่คุณเชิญ",
    "DailyTasksDesc": "ทำงานให้เสร็จเพื่อรับ ${name} เพิ่มเติม",
    "SponsorsandPartners": "ผู้สนับสนุนและพันธมิตร",
    "Receivingwallet": "กระเป๋าเงินสำหรับรับ",
    "Enterwalletaddress": "กรอกที่อยู่กระเป๋าเงิน {name}",
    "Claim": "รับ",
    "Booster": "บูสเตอร์",
    "RentPeriod": "ระยะเวลาการเช่า",
    "days30": "30 วัน",
    "days": "วัน",
    "Dailyprofit": "กำไรประจำวัน",
    "Totalprofit": "กำไรทั้งหมด",
    "Quantity": "จำนวน",
    "RentPrice": "ราคาค่าเช่า",
    "RentMiner": "เช่าเหมือง",
    "Insufficient": "เงินไม่เพียงพอ ${name}",
    "InsufficientMsg": "ต้องการ {num} ${name1} เชิญเพื่อนหรือทำงานให้เสร็จเพื่อเพิ่ม ${name2}.",
    "Settings": "ตั้งค่า",
    "copyid": "คัดลอก ID",
    "UpgradeSuccessfully": "อัปเกรดสำเร็จ",
    "Name": "ชื่อ",
    "userinfo": "ข้อมูลผู้ใช้",
    "disconnect": "ตัดการเชื่อมต่อ",
    "Startmining": "เริ่มขุด",
    "Welcome": "ยินดีต้อนรับสู่ {name}",
    "Withdrawal": "การถอน",
    "Minimumamount": "จำนวนขั้นต่ำ",
    "Networkfee": "ค่าธรรมเนียมเครือข่าย",
    "Enteramount": "กรอกจำนวน",
    "Submit": "ส่ง",
    "MinimumTip": "จำนวนที่ถอนน้อยเกินไป จำนวนถอนขั้นต่ำ: {num}",
    "MaximumTip": "จำนวนไม่เพียงพอ จำนวนสูงสุดที่คุณสามารถถอนคือ: {num}",
    "SubmittedTip": "ส่งแล้ว คาดว่าจะดำเนินการภายใน 30-60 วันทำการ",
    "WebSubmittedTip": "ส่งแล้ว คาดว่าจะดำเนินการภายใน 24-48 ชั่วโมง",
    "WithdrawStatus": "สถานะ",
    "Submissiontime": "เวลาส่ง",
    "WithdrawAwaitTip": "* คาดว่าจะใช้เวลา 30-60 วันทำการ การเชิญเพื่อนเพิ่มสามารถเร่งกระบวนการตรวจสอบได้",
    "WebWithdrawAwaitTip": "* คาดว่าจะใช้เวลา 24-48 ชั่วโมง การเชิญเพื่อนเพิ่มสามารถเร่งกระบวนการตรวจสอบได้",
    "Processing": "กำลังดำเนินการ",
    "Success": "สำเร็จ",
    "Rejection": "ถูกปฏิเสธ",
    "Amount": "จำนวน",
    "Numberoffriends": "จำนวนเพื่อน: {now}/{limit}",
    "InviteTip": "ในการถอนครั้งแรก คุณต้องเชิญ {limit} เพื่อนไปเข้าร่วมแอปขุด",
    "openonphone": "เปิดลิงก์นี้ในโทรศัพท์ของคุณ",
    "claimTip": "จำนวนที่จะได้รับรางวัลน้อยเกินไป จำนวนขั้นต่ำที่จะได้รับรางวัลคือ: {num}",
    "WalletBalance": "ยอดคงเหลือในกระเป๋าเงิน",
    "Withdraw": "ถอน",
    "SetWalletAddress": "ตั้งค่าที่อยู่กระเป๋าเงิน",
    "WithdrawalRecord": "บันทึกการถอน",
    "Norecords": "ไม่มีบันทึก",
    "Whatis": "{name} คืออะไร?",
    "All": "ทั้งหมด",
    "save": "บันทึก",
    "successWithdrawal": "การถอนได้รับแล้ว {num}",
    "secondsago": "{time} วินาทีที่แล้ว",
    "Loading": "กำลังโหลด...",
    "PaymentConfirming": "ตรวจสอบสถานะแบบรายการ...",
    "Check": "ตรวจสอบ",
    "CheckFail": "ธุรกรรมยังไม่เสร็จสมบูรณ์ กรุณาตรวจสอบอีกครั้งใน 5 วินาที",
    "Addname": "เพิ่ม '{name}' ในชื่อของคุณ",
    "Restattcheck": "เริ่มแอปใหม่เพื่อตรวจสอบ",
    "Copyname": "คัดลอก '{name}'",
    "SubmissionFailed": "การส่งล้มเหลว กรุณาลองอีกครั้งภายหลัง",
    "WithdrawalReview": "ตรวจสอบการถอน",
    "shop": "ร้านค้า",
    "topurchase": "ไปที่ร้านเพื่อทำการซื้อ",
    "shopDesc": "จำนวนจำกัด—รับของคุณก่อนที่จะหมด!",
    "select_payment_method": "เลือกวิธีการชำระเงิน",
    "total_amount": "จำนวนทั้งหมด",
    "creating_order": "กำลังสร้างคำสั่ง...",
    "order_created": "คำสั่งถูกสร้างแล้ว",
    "order_status": "สถานะคำสั่ง",
    "claim": "รับรางวัล",
    "payment_success": "ชำระเงินสำเร็จ",
    "payment_failed": "ชำระเงินล้มเหลว",
    "payment_cancelled": "ชำระเงินถูกยกเลิก",
    "opening_payment": "กำลังเปิดการชำระเงิน...",
    "payment_status": "สถานะการชำระเงิน",
    "create_order_failed": "การสร้างคำสั่งซื้อไม่สำเร็จ",
    "creating_ton_order": "กำลังสร้างคำสั่งซื้อ TON...",
    "next_step": "ขั้นตอนถัดไป",
    "use_ton_payment": "ใช้การชำระเงิน TON",
    "start_transaction": "เริ่มธุรกรรม",
    "connect_wallet": "เชื่อมต่อกระเป๋าเงิน",
    "address": "ที่อยู่",
    "amount_ton": "จำนวน TON",
    "copy": "คัดลอก",
    "amount": "จำนวน",
    "wallet_address": "ที่อยู่กระเป๋าเงิน",
    "comment_memo": "ความคิดเห็น/หมายเหตุ",
    "you_can_choose_to_connect_wallet_to_pay": "คุณสามารถเลือกเชื่อมต่อกระเป๋าเงินเพื่อชำระเงิน",
    "or_manually_transfer_to_the_above_address": "หรือโอนด้วยตนเองไปยังที่อยู่ข้างต้น (โปรดทราบว่าจำนวนและหมายเหตุจะต้องตรงกัน)",
    "transaction_success": "ธุรกรรมสำเร็จ",
    "transaction_failed": "ธุรกรรมล้มเหลว",
    "transaction_error": "ข้อผิดพลาดของธุรกรรม",
    "transaction_status": "สถานะธุรกรรม",
    "transaction_id": "รหัสธุรกรรม",
    "transaction_amount": "จำนวนธุรกรรม",
    "transaction_status_desc": "คำอธิบายสถานะธุรกรรม",
    "payment_status_tip": "กรุณารอการยืนยันการชำระเงิน",
    "Applyforwithdrawal": "สมัครถอนเงิน",
    "Withdrawalunlock": "การปลดล็อกการถอน",
    "Close": "ปิด",
    "Delivering": "กำลังจัดส่ง",
    "Duetothelargenumber": "เนื่องจากจำนวนผู้รับที่มาก การแจก airdrop ของคุณคาดว่าจะมาถึงใน 15-20 วันทำการ",
    "WithdrawalunlockTip": "คุณต้อง {num} เชิญเพื่อนให้ครบเพื่อทำภารกิจ/ผูกกระเป๋าเงินเพื่อปลดล็อกการถอน",
    "select_network": "เลือกเครือข่าย",
    "confirm": "ยืนยัน",
    "switching_network": "กำลังเปลี่ยนเครือข่าย...",
    "network_switched": "เปลี่ยนเครือข่ายแล้ว",
    "use_usdt_payment": "ใช้การชำระเงินด้วย USDT",
    "or_manually_transfer_to_the_above_address_usdt": "โอนด้วยตนเองไปยังที่อยู่ข้างต้น (โปรดทราบว่าจำนวนเงินและที่อยู่ต้องเหมือนกันเป๊ะ)",
    "chain_type": "เครือข่าย",
    "check_transaction_status": "ตรวจสอบสถานะการทำธุรกรรม",
    "transaction_wait": "กำลังดำเนินการธุรกรรม คุณสามารถออกจากแอปได้ ข้อความจะแจ้งเตือนคุณเมื่อเสร็จสิ้น",
    "twa_pay_tip_with_memo": "กรุณายืนยันว่า ที่อยู่ จำนวน และหมายเหตุ สอดคล้องกันสำหรับการโอน",
    "twa_pay_tip": "กรุณายืนยันว่า ที่อยู่ และจำนวน ถูกต้องสำหรับการโอน",
    "creating_usdt_order": "กำลังสร้างคำสั่ง USDT...",
    "affiliate_programs": "โปรแกรม afiliate",
    "affiliate_programs_description": "เชิญเพื่อนให้เข้าร่วมแอปขุดและรับรางวัล.",
    "commission_details": "รายละเอียดค่าคอมมิชชั่น",
    "no_commission_records": "ไม่มีบันทึกค่าคอมมิชชั่น",
    "commission_list": "รายการค่าคอมมิชชั่น",
    "input_amount": "กรอกจำนวนเงิน",
    "max": "สูงสุด",
    "commission_input_amount": "กรอกจำนวนค่าคอมมิชชั่น",
    "min_commission": "จำนวนเงินถอนขั้นต่ำคือ {num}",
    "WithdrawalSuccess": "การถอนสำเร็จ",
    "WithdrawalFailed": "การถอนล้มเหลว",
    "WithdrawalProcessing": "กำลังดำเนินการถอน",
    "award": "รางวัล",
    "level": "ระดับ",
    "Share_to_group": "แชร์ไปยังกลุ่ม",
    "Exchange": "แลกเปลี่ยน",
    "balance_not_enough": "ยอดไม่พอ คุณสามารถแลกเปลี่ยนได้เพียง {num} {coin}",
    "exchange_fail": "การแลกเปลี่ยนล éch",
    "exchange_success": "การแลกเปลี่ยนสำเร็จ",
    "you_will_receive": "คุณจะได้รับ",
    "ShareToGroups": "แชร์ไปยังกลุ่ม",
    "Numberofgroups": "จำนวนกลุ่ม: {now}/{limit}",
    "Confirm": "ยืนยัน",
    "ShareToGroupsDesc": "แชร์ไปยังกลุ่มเพื่อรับ {name} เพิ่มเติม",
    "TokenAddress": "กรุณากรอกรายละเอียดการถอน เช่น หมายเลขการแลกเปลี่ยนหรือที่อยู่ USDT",
    "CashAddress": "กรุณากรอกรายละเอียดการถอน เช่น หมายเลขบัตรธนาคารหรือที่อยู่ USDT",
    "Cancel": "ยกเลิก",
    "min_withdrawal_amount": "จำนวนถอนขั้นต่ำคือ {num} {coin}",
    "max_withdrawal_amount": "จำนวนถอนสูงสุดคือ {num} {coin}",
    "withdrawal_failed": "การถอนล้มเหลว",
    "withdrawal_success": "ถอนเงินสำเร็จ",
    "PayNow": "ชำระเงินตอนนี้",
    "PaySkip": "จ่าย {num} เพื่อปลดล็อกการถอนเงินทันที",
    "NumberofGroups": "จำนวนกลุ่ม: {now}/{limit}",
    "SendMessage": "ส่งข้อความ",
    "NumberofShares": "จำนวนแชร์: {now}/{limit}",
    "NumberofTasks": "จำนวนงาน: {now}/{limit}",
    "CompleteTask": "ทำงานให้เสร็จ",
    "PleaseEnterValidAmount": "กรุณาใส่จำนวนเงินที่ถูกต้อง",
    "PleaseEnterValidEmail": "กรุณาใส่อีเมลที่ถูกต้อง",
    "Feedback": "ข้อเสนอแนะแสดงความคิดเห็น",
    "Inputfeedbackcontent": "กรอกเนื้อหาข้อเสนอแนะแสดงความคิดเห็น",
    "Submitfeedback": "ส่งข้อเสนอแนะแสดงความคิดเห็น",
    "Pleaseenteravalidemailaddress": "กรุณาใส่อีเมลที่ถูกต้อง",
    "Pleaseenteryouremailaddress": "กรุณาใส่อีเมลของคุณ",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "คุณได้แสดงความคิดเห็นในวันนี้แล้ว กรุณากลับมาในวันพรุ่งนี้",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "ส่งข้อเสนอแนะแสดงความคิดเห็นสำเร็จ ขอบคุณสำหรับข้อเสนอแนะที่มีค่า",
    "Feedback_submission_failed_please_retry": "การส่งข้อเสนอแนะแสดงความคิดเห็นล้มเหลว กรุณาลองอีกครั้ง",
    "ContactUs": "ติดต่อเรา",
    "XRPAddress": "กรุณากรอกที่อยู่กระเป๋า XRP ที่เปิดใช้งาน (รวมถึง MEMO) มิฉะนั้นคุณจะไม่สามารถถอนเงินสดได้",
    "Accelerated": "เร่งรัด",
    "Accelerated_withdrawals_success": "การถอนเงินที่เร่งรัดสำเร็จ",
    "login": "เข้าสู่ระบบ",
    "register": "ลงทะเบียน",
    "login_with_google": "เข้าสู่ระบบด้วย Google",
    "or": "หรือ",
    "email": "อีเมล",
    "password": "รหัสผ่าน",
    "no_account": "ยังไม่มีบัญชี",
    "click_to_go": "คลิกเพื่อ",
    "have_account": "มีบัญชีอยู่แล้ว",
    "go_to": "ไปที่",
    "invite_code": "รหัสเชิญ",
    "optional": "ไม่บังคับ",
    "google_login_not_ready": "การเข้าสู่ระบบผ่าน Google ยังไม่พร้อม กรุณาลองอีกครั้งภายหลัง",
    "password_too_long": "รหัสผ่านยาวเกินไป",
    "weak": "อ่อนแอ",
    "medium": "ปานกลาง",
    "strong": "แข็งแรง",
    "login_success": "เข้าสู่ระบบสำเร็จ",
    "login_failed": "เข้าสู่ระบบล échuté",
    "please_input_email": "กรุณาใส่อีเมลของคุณ",
    "invalid_email": "รูปแบบอีเมลไม่ถูกต้อง",
    "please_input_password": "กรุณาใส่รหัสผ่านของคุณ",
    "password_length_6_to_16": "รหัสผ่านต้องมี 6-16 อักษร",
    "account_or_password_error": "บัญชีหรือรหัสผ่านไม่ถูกต้อง",
    "register_success": "การลงทะเบียนสำเร็จ",
    "register_failed": "การลงทะเบียนล échuté",
    "save_error": "บันทึกข้อผิดพลาด, โปรดลองอีกครั้งในภายหลัง",
    "ShareToFriends": "แชร์ให้เพื่อน",
    "login_first": "กรุณาเข้าสู่ระบบก่อน",
    "WalletBscError": "❌ ที่อยู่กระเป๋าเงิน BNB Chain ไม่ถูกต้อง.",
    "DownloadWallet": "ดาวน์โหลดกระเป๋าเงิน",
    "AddToHomeScreen": "เพิ่ม {appName} ลงในหน้าแรก",
    "TapShareInToolbar": "แตะที่แถบเครื่องมือ",
    "SelectAddToHomeScreen": "เลือกเพิ่มลงในหน้าแรก",
    "OpenToolbar": "เปิดแถบเครื่องมือ",
    "ClaimFailed": "ไม่สามารถรับรางวัลได้ โปรดลองอีกครั้งในภายหลัง",
    "guest_login": "เข้าสู่ระบบผู้เยี่ยมชม",
    "please_input_phone": "กรุณาใส่หมายเลขโทรศัพท์ของคุณ",
    "email_error_1": "กรุณาใส่อีเมลของคุณ",
    "email_error_2": "กรุณาใส่อีเมลที่ถูกต้อง",
    "email_error_3": "อีเมลของผู้เยี่ยมชมไม่อนุญาต กรุณาใช้อีเมลจริง",
    "phone": "โทรศัพท์",
    "phone_error_1": "กรุณาใส่หมายเลขโทรศัพท์ของคุณ",
    "phone_error_2": "กรุณาใส่หมายเลขโทรศัพท์ที่ถูกต้อง",
    "update_info": "อัปเดตข้อมูล",
    "update_success": "อัปเดตสำเร็จ",
    "update_failed": "การอัปเดตล้มเหลว กรุณาลองอีกครั้งในภายหลัง",
    "cancel": "ยกเลิก",
    "guest_credentials_title": "ข้อมูลบัญชี",
    "guest_credentials_warning": "กรุณาถ่ายภาพหน้าจอเพื่อตรวจสอบบัญชีและรหัสผ่านของคุณ หากสูญหาย รายได้ของคุณไม่สามารถกู้คืนได้!",
    "i_have_saved": "ฉันได้บันทึก",
    "account": "บัญชี",
    "view_credentials": "ดูข้อมูลประจำตัว",
    "miner_max_reached": "คุณถึงจำนวนสูงสุดของเหมืองนี้แล้ว"
}};